import React from "react";
import "./Actions.css";

import { ReactComponent as ViewIcon } from "common/assets/icons/eye.svg";
import { ReactComponent as SendIcon } from "common/assets/icons/send.svg";
import { ReactComponent as HistoryIcon } from "common/assets/icons/history.svg";
import { ReactComponent as DeleteIcon } from "common/assets/icons/trash.svg";
import { ActionsProps } from "./Actions.props";

const Actions: React.FC<ActionsProps> = ({
	onView,
	onSend,
	onHistory,
	onClick,
	onDelete,
}) => {
	return (
		<div
			className="grid grid-flow-col gap-6 auto-cols-max"
			onClick={(e) => {
				if (onClick) {
					onClick(e);
				}
			}}
		>
			{onView && (
				<ViewIcon
					onClick={onView}
					className="w-5 h-5 cursor-pointer stroke-passiveTextColor"
				/>
			)}
			{onSend && (
				<SendIcon
					onClick={onSend}
					className="w-5 h-5 cursor-pointer stroke-passiveTextColor"
				/>
			)}
			{onDelete && (
				<DeleteIcon
					onClick={onDelete}
					className="w-5 h-5 cursor-pointer stroke-passiveTextColor"
				/>
			)}
			{onHistory && (
				<HistoryIcon
					onClick={onHistory}
					className="w-5 h-5 cursor-pointer stroke-passiveTextColor"
				/>
			)}
		</div>
	);
};

export default Actions;
